import { CheckCircleRounded, Close, ErrorRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, Typography, } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import React from 'react';
function formatInspectionModeLabel(mode) {
    if (mode === 'defects_first') {
        return 'Акцент на важном (быстрый)';
    }
    return 'По умолчанию (подробный)';
}
function formatSummaryPositionLabel(mode, position) {
    if (mode !== 'defects_first') {
        return '—';
    }
    return position === 'start' ? 'В начале шаблона' : 'В конце шаблона';
}
const TransportInspectionDialog = ({ open, onClose, defaultValues }) => {
    var _a, _b;
    if (!defaultValues) {
        return null;
    }
    const checkpoints = (_a = defaultValues.checkpoints) !== null && _a !== void 0 ? _a : [];
    const results = (_b = defaultValues.results) !== null && _b !== void 0 ? _b : [];
    return (React.createElement(Dialog, { maxWidth: 'md', fullWidth: true, open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '500px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(1.5),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                'path, circle': {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(InspectionIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'p' }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u043E\u0441\u043C\u043E\u0442\u0440\u0435"),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(List, { sx: (theme) => ({
                        '.MuiListItem-root': {
                            border: '1px solid',
                            borderColor: theme.palette.divider,
                            borderRadius: theme.spacing(1),
                            marginBottom: theme.spacing(2),
                            '&[data-error="true"]': {
                                borderColor: theme.palette.error.main,
                            },
                            '&:last-of-type': {
                                marginBottom: 0,
                            },
                            '.MuiListItemText-root:nth-of-type(1) span': {
                                color: theme.palette.text.secondary,
                            },
                            '.MuiListItemText-root:nth-of-type(2)': {
                                textAlign: 'right',
                            },
                        },
                    }) },
                    React.createElement(ListItem, null,
                        React.createElement(ListItemText, { primary: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0441\u043C\u043E\u0442\u0440\u0430' }),
                        React.createElement(ListItemText, { primary: defaultValues.name })),
                    React.createElement(ListItem, null,
                        React.createElement(ListItemText, { primary: '\u0420\u0435\u0436\u0438\u043C \u043E\u0441\u043C\u043E\u0442\u0440\u0430' }),
                        React.createElement(ListItemText, { primary: formatInspectionModeLabel(defaultValues.inspection_mode) })),
                    React.createElement(ListItem, null,
                        React.createElement(ListItemText, { primary: '\u0411\u043B\u043E\u043A \u0441\u0430\u043C\u043C\u0430\u0440\u0438' }),
                        React.createElement(ListItemText, { primary: formatSummaryPositionLabel(defaultValues.inspection_mode, defaultValues.summary_position) })),
                    React.createElement(ListItem, null,
                        React.createElement(ListItemText, { primary: '\u0412\u0440\u0435\u043C\u044F \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E\u0441\u043C\u043E\u0442\u0440\u0430' }),
                        React.createElement(ListItemText, { primary: moment(defaultValues.created_at).format('DD.MM.YYYY HH:mm:ss') })),
                    checkpoints.map((checkpoint, index) => {
                        const [type, title, , required] = checkpoint;
                        const status = required ? !results[index] : false;
                        const resultValue = results[index];
                        switch (type) {
                            case 'number':
                            case 'select':
                                return (React.createElement(ListItem, { "data-error": status, key: index },
                                    React.createElement(ListItemText, { primary: title }),
                                    React.createElement(ListItemText, { primary: resultValue })));
                            case 'textarea':
                                return (React.createElement(ListItem, { key: index, "data-error": status, sx: (theme) => ({
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        padding: 0,
                                        overflow: 'hidden',
                                        '.MuiListItemText-root': {
                                            width: '100%',
                                            paddingTop: '8px',
                                            paddingBottom: '12px',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: 0,
                                            borderBottom: '1px solid',
                                            borderColor: theme.palette.divider,
                                        },
                                        'p.MuiTypography-root': {
                                            paddingTop: '8px',
                                            paddingBottom: '12px',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                        },
                                    }) },
                                    React.createElement(ListItemText, { primary: title }),
                                    React.createElement(Typography, { component: 'p' }, resultValue)));
                            case 'photo':
                                return (React.createElement(ListItem, { key: index, "data-error": status, sx: (theme) => ({
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        padding: 0,
                                        overflow: 'hidden',
                                        '.MuiListItemText-root': {
                                            width: '100%',
                                            paddingTop: '8px',
                                            paddingBottom: '12px',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            marginBottom: 0,
                                            borderBottom: '1px solid',
                                            borderColor: theme.palette.divider,
                                        },
                                    }) },
                                    React.createElement(ListItemText, { primary: title }),
                                    React.createElement(Box, { component: 'div', sx: {
                                            width: '100%',
                                            height: '200px',
                                            bgcolor: 'black',
                                            'a, img': {
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                            },
                                        } },
                                        React.createElement("a", { href: `${location.origin}/resources/${resultValue}`, target: '_blank', rel: 'noreferrer' },
                                            React.createElement("img", { src: `${location.origin}/resources/${resultValue}`, alt: '' })))));
                            case 'boolean':
                                return (React.createElement(ListItem, { "data-error": status, key: index },
                                    React.createElement(ListItemText, { primary: title }),
                                    resultValue ? (React.createElement(CheckCircleRounded, { fontSize: 'small', color: 'success' })) : (React.createElement(ErrorRounded, { fontSize: 'small', color: 'error' }))));
                            default:
                                return null;
                        }
                    })))),
        React.createElement(DialogActions, null,
            React.createElement(LoadingButton, { variant: 'contained', color: 'primary', onClick: onClose, disableElevation: true }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))));
};
export default TransportInspectionDialog;
